import React from 'react';
import classnames from 'classnames';

import AccountPackages from '../../components/accountComponents/AccountPackages';
import { PROMO_CODES } from '../../constants/promoCodes';


function FanzoneSubscription(props) {
  const {
    activeCampaign,
    amountParam,
    anchorLeftImage,
    anchorPortalCampaign,
    anchorRightImage,
    anchorShortUrl,
    anchorSubscriptionPrograms,
    anchorToSubscribe,
    createAccountImage,
    createdUser,
    disableOneClickPaysafe,
    feeIsAdded,
    fetchPackages,
    hasPromoInURL,
    isCampaignActive,
    isInvisible,
    isMembershipCheckoutPage,
    listOfActiveCampaigns,
    showPromoInput,
    token,
    user,
  } = props;

  if (activeCampaign?.affiliateCode === PROMO_CODES.CYBERMONDAY23 && isCampaignActive) {
    return (
      <React.Fragment>
        <div
          className={classnames(
            'col-sm-12',
            'col-xs-12',
            {
              'col-md-6': !isMembershipCheckoutPage,
              'col-md-3 accounts-right-image': isMembershipCheckoutPage,
            })}
          style={{ textAlign: 'right' }}
        >
          <img alt="" src={anchorLeftImage} />
        </div>
        <div
          className={classnames(
            'col-sm-12',
            'col-xs-12',
            {
              'col-md-6': !isMembershipCheckoutPage,
              'col-md-3 account-left-section': isMembershipCheckoutPage,
            })}
        >
          <AccountPackages
            NNLivePromoPage={false}
            NNPromoPage={false}
            activeCampaign={activeCampaign}
            amountParam={amountParam}
            anchorPortalCampaign={anchorPortalCampaign}
            anchorShortUrl={anchorShortUrl}
            anchorSubscriptionPrograms={anchorSubscriptionPrograms}
            anchorToSubscribe={anchorToSubscribe}
            createdUser={createdUser}
            disableOneClickPaysafe={disableOneClickPaysafe}
            fanzoneCampaign={true}
            feeIsAdded={feeIsAdded}
            fetchPackages={fetchPackages}
            hasPromoInURL={hasPromoInURL}
            isCampaignActive={isCampaignActive}
            isInvisible={isInvisible}
            isMembershipCheckoutPage={isMembershipCheckoutPage}
            isMembershipPaymentPage={isMembershipCheckoutPage}
            listOfActiveCampaigns={listOfActiveCampaigns}
            programs={anchorSubscriptionPrograms}
            showPromoInput={showPromoInput}
            token={token}
            user={user}
          />
        </div>
        <div
          className={classnames(
            'col-sm-12',
            'col-xs-12',
            {
              'col-md-6 hide': !isMembershipCheckoutPage,
              'col-md-3 image-right accounts-right-image': isMembershipCheckoutPage,
            })}
          style={{ textAlign: 'right' }}
        >
          <img alt="" src={anchorRightImage} />
        </div>
      </React.Fragment>
    );
  }

  return (
    <>
      <div className="col-md-6 col-sm-12 col-xs-12">
        <AccountPackages
          activeCampaign={{}}
          amountParam={amountParam}
          anchorPortalCampaign={anchorPortalCampaign}
          anchorShortUrl={anchorShortUrl}
          anchorSubscriptionPrograms={anchorSubscriptionPrograms}
          anchorToSubscribe={anchorToSubscribe}
          disableOneClickPaysafe={disableOneClickPaysafe}
          feeIsAdded={feeIsAdded}
          fetchPackages={fetchPackages}
          hasPromoInURL={hasPromoInURL}
          isCampaignActive={isCampaignActive}
          isInvisible={isInvisible}
          isMembershipCheckoutPage={isMembershipCheckoutPage}
          listOfActiveCampaigns={listOfActiveCampaigns}
          showPromoInput={showPromoInput}
          user={user}
        />
      </div>
      <div
        className="col-md-6 col-sm-12 col-xs-12 accounts-right-image"
        style={{ textAlign: 'right' }}
      >
        <img alt="" src={createAccountImage.anchorImage} />
      </div>
    </>
  );
}

export default FanzoneSubscription;
